export const virtualsRowSportIds = new Set([118, 55, 54, 150]);
